import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class GroupAPI {

    constructor(http) {
        this.http = http
    }

    getList(token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });
        this.http.get('api/contact/groupList')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("groups"))
                        successCallback(json.groups);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    getListWithPagination(page, limit, sortBy, sortDir,token, successCallback, errorCallback) {

      this.http = this.http.configure(x => {
          x.withHeader('Content-Type', 'application/json')
          .withHeader("Authorization", token);

      });

      var queryString = "?page=" + page;
      queryString += "&limit=" + limit;
      queryString += "&sortBy=" + sortBy;
      queryString += "&sortDir=" + sortDir;

      this.http.get('api/contact/groupList'+queryString)
          .then(data => {

              if (data.isSuccess) {
                  var json = JSON.parse(data.response);

                  if(json.hasOwnProperty("groups"))
                      successCallback(json.groups);

                  if(json.hasOwnProperty("error"))
                      errorCallback(json.error);

              }
              else {
                  errorCallback(data.statusText);
              }
          });

  }

    save(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.post('api/contact/addGroup', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("groups"))
                        successCallback(json.groups);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
saveGroup(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.post('api/contact/addGroup', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("groups"))
                        successCallback(json.groups);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    delete(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.post('api/contact/deleteGroup', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("groups"))
                        successCallback(json.groups);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    //Group Related Functions
    /*saveGroup(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.post('api/contact/addGroup', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("groups"))
                        successCallback(json.groups);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }*/
    /*deleteGroup(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.post('api/contact/deleteGroup', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("groups"))
                        successCallback(json.groups);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }*/
    /*getGroupList(token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/contact/groupList')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("groups"))
                        successCallback(json.groups);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }*/
    //Group Related Functions

}
